import script from "./CategoryTreeItem.vue?vue&type=script&setup=true&lang=js"
export * from "./CategoryTreeItem.vue?vue&type=script&setup=true&lang=js"

import "./CategoryTreeItem.vue?vue&type=style&index=0&id=6779e2cc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6779e2cc"]])

export default __exports__